import type { NotificationTag } from '~/features/notifications/types/notifications.api.types';
import { cn } from '~/utils/cn';

const TAG_STYLES: Record<NotificationTag, string> = {
  Critical: 'bg-red-100 text-red-700 border-red-200',
  Warning: 'bg-amber-100 text-amber-700 border-amber-200',
  'Action Needed': 'bg-blue-100 text-blue-700 border-blue-200',
  Info: 'bg-gray-100 text-gray-600 border-gray-200',
  NEW: 'bg-indigo-600 text-white border-indigo-600',
  Applied: 'bg-green-100 text-green-700 border-green-200',
  Validated: 'bg-teal-100 text-teal-700 border-teal-200',
};

interface Props {
  tag: NotificationTag;
  /** 'sm' for compact dropdown rows; 'md' for full-page cards (default: 'sm'). */
  size?: 'sm' | 'md';
}

/** Colored pill badge for a notification tag. */
export function NotificationTagBadge({ tag, size = 'sm' }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded border leading-none font-semibold',
        size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'rounded-md px-1.5 py-1 text-[11px]',
        TAG_STYLES[tag],
      )}
    >
      {tag}
    </span>
  );
}
